const state = {
    visibilityFooter: false
};

const getters = {
    getVisibilityFooter: state => state.visibilityFooter
};

const actions = {
    showFooter({ commit }) {
        commit('setVisibilityFooter', true);
    },
    hideFooter({ commit }) {
        commit('setVisibilityFooter', false);
    }
};

const mutations = {
    setVisibilityFooter: (state, visibility) => {
        state.visibilityFooter = visibility
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};